/**
 * Roles:
 * - admin:   platform_admins table (checked via RPC auth_is_platform_admin)
 * - manager: user_metadata.role = 'manager'
 * - barista: user_metadata.role = 'barista' | 'personnel'
 *
 * Never use user_metadata or app_metadata for admin — both are hijackable.
 */

const adminCache = new Map();

export function clearPlatformAdminCache(userId) {
  if (userId) adminCache.delete(userId);
  else adminCache.clear();
}

/** Server-backed admin check (platform_admins). */
export async function checkIsPlatformAdmin(supabase, user) {
  if (!user?.id) return false;
  const hit = adminCache.get(user.id);
  if (hit && Date.now() - hit.at < 60_000) return hit.value;

  const { data, error } = await supabase.rpc('auth_is_platform_admin');
  const value = !error && data === true;
  adminCache.set(user.id, { value, at: Date.now() });
  return value;
}

/** @deprecated JWT metadata — always false. Use checkIsPlatformAdmin. */
export function isAdminUser() {
  return false;
}

export function isManagerUser(user) {
  if (!user) return false;
  return user.user_metadata?.role === 'manager';
}

export function isBaristaUser(user) {
  if (!user) return false;
  const r = user.user_metadata?.role;
  return r === 'barista' || r === 'personnel';
}

export function isFieldStaffUser(user) {
  return isBaristaUser(user) || isManagerUser(user);
}
